import { SystemStyleObject } from "@chakra-ui/react";

export const individualDetailsQuickActionBtnCss: SystemStyleObject = {
  border: "1px solid #D0D5DD",
  height: "40px",
  borderRadius: "8px",
  padding: "10px 18px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  boxShadow: "0px 1px 2px 0px #1018280D",
};

export const individualDetailsQuickActionBtnCss3: SystemStyleObject = {
  border: "1px solid #D0D5DD",
  height: "36px",
  width: "36px",
  borderRadius: "8px",
  padding: "10px 18px",
  display: "flex",
  alignItems: "center",
  gap: "4px",
  boxShadow: "0px 1px 2px 0px #1018280D",
};

export const moreQuickActionsDropDownPopUpMenuContentCss: SystemStyleObject = {
  height: "80px",
  borderRadius: "8px",
  backgroundColor: "#ffffff",
  border: "1px solid #F2F4F7",
  padding: "0 16px",
  boxShadow: "0px 12px 16px -4px #10182814",
};

export const moreQuickActionsDropDownPopUpMenuContentCss3: SystemStyleObject = {
  height: "121px",
  borderRadius: "8px",
  backgroundColor: "#ffffff",
  border: "1px solid #F2F4F7",
  padding: "0 16px",
  boxShadow: "0px 12px 16px -4px #10182814",
};

export const moreQuickActionsDropDownPopUpMenuContentCss4: SystemStyleObject = {
  height: "161px",
  borderRadius: "8px",
  backgroundColor: "#ffffff",
  border: "1px solid #F2F4F7",
  padding: "0 16px",
  boxShadow: "0px 12px 16px -4px #10182814",
};

export const transactionLimitModalHeaderCss: SystemStyleObject = {
  marginBottom: 0,
};
